import { render } from "./LoadingPlaceholder.vue?vue&type=template&id=264d8dc8&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=264d8dc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264d8dc8"]])

export default __exports__